import {Platform} from 'react-native';

import {
  BIOMETRIC_FACE,
  BIOMETRIC_FACE_ID,
  BIOMETRIC_FINGERPRINT,
  BIOMETRIC_IRIS,
  BIOMETRIC_TOUCH_ID,
} from '/enum/biometrics.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {generateCallback} from '/util/component.util';
import {
  changePin,
  turnOffBiometricsSwitch,
  turnOffPin,
  turnOnBiometrics,
  turnOnPin,
} from '/util/pinUI.util';

export const useGetItems = ({
  biometricType,
  handleBiometricsOptIn,
  biometricsOptIn,
}: any) => {
  const items = [];
  if (!biometricType || biometricType === BIOMETRIC_FACE_ID) {
    items.push({
      title:
        Platform.OS === 'ios'
          ? withTranslation.tt('useFaceID', 'Use Face ID')
          : withTranslation.tt('useTouchID', 'Use Touch ID'),
      onToggleSwitch: generateCallback({func: handleBiometricsOptIn}),
      isEnabled: biometricsOptIn,
      enableSwitch: true,
      accessibilityRole: 'switch',
      accessibilityLabel:
        Platform.OS === 'ios'
          ? 'Use Face ID Toggle Switch'
          : 'Use Touch ID Toggle Switch',
    });
  } else if (biometricType === BIOMETRIC_TOUCH_ID) {
    items.push({
      title: withTranslation.tt('useTouchID', 'Use Touch ID'),
      onToggleSwitch: generateCallback({func: handleBiometricsOptIn}),
      isEnabled: biometricsOptIn,
      enableSwitch: true,
      accessibilityRole: 'switch',
      accessibilityLabel: 'Use Touch ID Login Toggle',
    });
  } else if (biometricType === BIOMETRIC_FINGERPRINT) {
    items.push({
      title: withTranslation.tt('useBiometrics', 'Use Finger Recognition'),
      onToggleSwitch: generateCallback({func: handleBiometricsOptIn}),
      isEnabled: biometricsOptIn,
      enableSwitch: true,
      accessibilityRole: 'switch',

      accessibilityLabel: 'Use Finger Recognition Login Toggle',
    });
  } else if (biometricType === BIOMETRIC_FACE) {
    items.push({
      title: withTranslation.tt('useBiometrics', 'Use Face Recognition'),
      onToggleSwitch: generateCallback({func: handleBiometricsOptIn}),
      isEnabled: biometricsOptIn,
      enableSwitch: true,
      accessibilityRole: 'switch',
      accessibilityLabel: 'Use Face Recognition Login Toggle',
    });
  } else if (biometricType === BIOMETRIC_IRIS) {
    items.push({
      title: withTranslation.tt('useBiometrics', 'Use Iris Unlock'),
      onToggleSwitch: generateCallback({func: handleBiometricsOptIn}),
      isEnabled: biometricsOptIn,
      enableSwitch: true,
      accessibilityRole: 'switch',
      accessibilityLabel: 'Use Iris Unlock Login Toggle',
    });
  }

  return items;
};

export const useGetPinItems = ({
  handlePinOptIn,
  pinOptIn,
  showPopup,
  hidePopup,
}: any) => {
  return [
    {
      title: withTranslation.tt('usePin', 'Use PIN'),
      onToggleSwitch: generateCallback({func: handlePinOptIn}),
      isEnabled: pinOptIn,
      // isDisabled: !biometricType ? false : biometricsOptIn,
      enableSwitch: true,
      accessibilityRole: 'switch',
      // buttonDisabled: !biometricType ? false : biometricsOptIn,
      accessibilityLabel: 'Use PIN Login Toggle',
    },
    {
      title: withTranslation.tt('changePin', 'Change PIN'),
      enableSwitch: false,
      isClickable: true,
      buttonDisabled: !pinOptIn,
      onPress: changePin({showPopup, hidePopup}),
      accessibilityRole: 'switch',
      accessibilityLabel: 'Change PIN Login Toggle',
    },
  ];
};

export const handleBiometricsOptIn =
  ({
    showPopup,
    setBiometricsOptInValue,
    setBiometricsOptIn,
    hidePopup,
    getBiometricsOptInValue,
    biometricsOptIn,
    biometricType,
    setbiometricsWasRequested,
  }: any) =>
  async () => {
    const args = {
      setBiometricsOptInValue,
      setBiometricsOptIn,
      showPopup,
      hidePopup,
      biometricsOptIn,
      biometricType,
      setbiometricsWasRequested,
    };
    await getBiometricsOptInValue().then((val: any) =>
      !val ? turnOnBiometrics(args)() : turnOffBiometricsSwitch({...args})(),
    );
    return setBiometricsOptInValue(!biometricsOptIn).then(
      generateCallback({func: setBiometricsOptIn, params: !biometricsOptIn}),
    );
  };

export const handlePinOptIn =
  ({
    showPopup,
    setPinOptInValue,
    setPinOptIn,
    hidePopup,
    getUserPinValue,
    pinOptIn,
    getPinOptInValue,
  }: any) =>
  async () => {
    const args = {showPopup, setPinOptInValue, setPinOptIn, hidePopup};
    await getPinOptInValue().then((val: any) =>
      !val ? turnOnPin(args)() : turnOffPin({...args, getUserPinValue})(),
    );
    return setPinOptInValue(!pinOptIn).then(
      generateCallback({func: setPinOptIn, params: !pinOptIn}),
    );
  };
